import { initializeApp, getApps } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence, type Auth } from 'firebase/auth';
import type { FirebaseApp } from 'firebase/app';

const baseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY as string,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN as string,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID as string,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID as string,
} as const;

const firebaseConfig = (() => {
  const id = process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID;
  return id ? { ...baseConfig, measurementId: id } : baseConfig;
})();

let appInstance: FirebaseApp | null = null;
let authInstance: Auth | null = null;
let persistenceInitialized = false;

export function getFirebaseApp(): FirebaseApp {
  if (appInstance) return appInstance;
  const existingApp = getApps()[0];
  appInstance = existingApp ?? initializeApp(firebaseConfig);
  return appInstance;
}

export function getFirebaseAuth(): Auth {
  if (!authInstance) {
    authInstance = getAuth(getFirebaseApp());
  }
  if (typeof window !== 'undefined' && !persistenceInitialized) {
    persistenceInitialized = true;
    void setPersistence(authInstance, browserLocalPersistence).catch(() => {
      persistenceInitialized = false;
    });
  }
  return authInstance;
}

export default getFirebaseApp;
